import React, { Component } from 'react'
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { EmployeeMasterPopup } from './EmployeeMasterTable';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';
import { decryptAES } from '../../../utils/Encryption';

export default class EmployeeMaster extends Component {
  constructor(props) {
    super(props)
    this.accountTransactionServices = new AccountTransactionServices();
    this.masterEntryServices = new MasterEntryServices();
    this.SwalServices = new SwalServices();
    this.state = {
      urlId: 0,
      permissions: {
        isAddEdit: false,
        isDelete: false,
        isView: false,
      },
      isModalOpen: false,
      rowData: [],
      colDefs: [],
      paginationPageSize: 50,
      rowHeight: 40,
      idCompany: 0,
      idUser: 0,
      employeeObject: {
        idEmployee: 0,
        updateStatus: 0,
        idCompany: 0,
        empCode: '',
        empGrpId: 0,
        empGrpName: '',
        selectedEmpGrp: [],
        empName: '',
        designationId: 0,
        designationName: '',
        selectedDesignation: {},
        departmentId: 0,
        departmentName: '',
        selectedDepartment: {},
        address: '',
        contactNo: '',
        email: '',
        joiningDate: '',
        accNo: '',
        pfNo: '',
        esicNo: '',
        basic: 0,
        hra: 0,
        conv: 0,
        spAllow: 0,
        grossSalary: '',
        pf: '',
        profTax: '',
        esicAmt: '',
        tdsGrpId: 0,
        tdsGrpName: "",
        selectedTDSGroups: {},
        tds: '',
        bloodgrpId: 0,
        bloodgrpName: "",
        selectedBloodGroups: {},
        birthDate: '',
        opDate: '',
        opBalanceTypeId: 1,
        opBalanceTypeName: 'CREDIT',
        selectedOpBalanceType: {},
        opBalance: '',
        expClosing: "",
        expOPTypeId: "",
        expOPTypeName: "",
        selectedExpOPType: {},
        accSubHeadId: 0,
        accSubHeadName: '',
        selectedGeneralProducts: {},
        remarks: '',
        isLeave: false,
        leaveDate: '',
        e_Date: "",
        designations: [],
        departments: [],
        employeeGroups: [],
        generalProducts: [],
        tdsGroups: [],
        bloodGroups: [
          {
            value: 1,
            label: "A+"
          },
          {
            value: 2,
            label: "A-"
          },
          {
            value: 3,
            label: "B+"
          },
          {
            value: 4,
            label: "B-"
          },
          {
            value: 5,
            label: "O+"
          },
          {
            value: 6,
            label: "O-"
          },
          {
            value: 7,
            label: "AB+"
          },
          {
            value: 8,
            label: "AB-"
          }
        ],

        types: [
          {
            value: 1,
            label: "CREDIT",
          },
          {
            value: 2,
            label: "DEBIT",
          }
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRules: {
        empName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "employee name"
            ),
          },
        ],
        // contactNo: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "contact number"
        //     ),
        //   },
        // ],
        // email: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "email address"
        //     ),
        //   },
        // ],
        // joiningDate: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "joining date"
        //     ),
        //   },
        // ],
        // accNo: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "account no"
        //     ),
        //   },
        // ],
        // opDate: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "opening date"
        //     ),
        //   },
        // ],
        // opBalance: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "opening balance"
        //     ),
        //   },
        // ],
        // selectedGeneralProducts: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "account sub head"
        //     ),
        //   },
        // ],
        // empGrpId: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "emp grp"
        //     ),
        //   },
        // ],
        designationId: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "designation"
            ),
          },
        ],
        // departmentId: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "department"
        //     ),
        //   },
        // ],
        // accSubHeadId: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "acc sub head"
        //     ),
        //   },
        // ],
        opBalanceTypeId: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "opening balance type"
            ),
          },
        ],
      },
    }
  }



  openPopUpForAddingItem = () => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.add);
      return;
    }
    this.setState({ isModalOpen: true }, () => {
      this.resetDetailsFields();
    })
  };

  onRowDoubleClicked = (event) => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.edit);
      return;
    }
    this.getEmployeeMasterDetails(event.data.idEmployee);
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    this.setState({ validState: validState })
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.employeeObject,
      this.state.validationRules,
      this.state.validState,
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  }

  setOpenModel = () => {
    if (this.state.urlId) {
      this.setState({ route: '/ledger-report' });
    }
    this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
      this.resetDetailsFields();
    });
  };
  closePopup = () => {
    if (this.state.urlId) {
      this.setState({ route: '/ledger-report' });
    }
    this.setState({ isModalOpen: false, }, () => {
      this.resetDetailsFields();
    });
  };

  handleChange = (event, name) => {
    let details = this.state.employeeObject;
    if (name === 'empGrpName') {
      details.empGrpId = event.value;
      details.empGrpName = event.label;
      // details.empGrpId = { ...event };
    } else if (name === 'Designation') {
      details.designationId = event.value;
      details.designationName = event.label;
      // details.designationId = { ...event };
    } else if (name === 'Department') {
      details.departmentId = event.value;
      details.departmentName = event.label;
      // details.departmentId = { ...event };
    } else if (name === 'TDSGroups') {
      details.tdsGrpId = event.value;
      details.tdsGrpName = event.label;
      // details.tdsGrpId = { ...event };
    } else if (name === 'BloodGroups') {
      details.bloodgrpId = event.value;
      details.bloodgrpName = event.label;
      // details.bloodgrpId = { ...event };
    } else if (name === 'OpBalanceType') {
      details.opBalanceTypeId = event.value;
      details.opBalanceTypeName = event.label;
      // details.opBalanceTypeId = { ...event };
    } else if (name === 'EexpOPTypeName') {
      details.expOPTypeId = event.value;
      details.expOPTypeName = event.label;
      details.expOPTypeId = { ...event };
    } else if (name === 'AccSubHead') {
      details.accSubHeadId = event.value;
      details.accSubHeadName = event.label;
      // details.accSubHeadId = { ...event };
    }
    else {
      let value = event.target.value;
      if (name === "isLeave") {
        details.isLeave = !details.isLeave;
      } else {
        details[name] = value;
      }
    }
    this.setState({ employeeObject: details }, () => {
      this.grossSalaryCalculation();
    });
  }

  grossSalaryCalculation = () => {
    // private void SalaryCalc()
    //     {
    let data = this.state.employeeObject;
    // data.basic = ;
    // data.hra = ;
    // data.conv = ;
    // data.spAllow = ;
    //data.basic = string.IsNullOrEmpty(txtBasicAmt.Text) ? 0 : Convert.ToDouble(txtBasicAmt.Text);
    //var hra = string.IsNullOrEmpty(txtHRAAmt.Text) ? 0 : Convert.ToDouble(txtHRAAmt.Text);
    //var conv = string.IsNullOrEmpty(txtConvAmt.Text) ? 0 : Convert.ToDouble(txtConvAmt.Text);
    //var specialAll = string.IsNullOrEmpty(txtSpecialAllowance.Text) ? 0 : Convert.ToDouble(txtSpecialAllowance.Text);
    //var gross = string.IsNullOrEmpty(txtSalary.Text) ? 0 : Convert.ToDouble(txtSalary.Text);
    var amt;
    var pTamt;
    var esicAmt;
    amt = Math.round(Number(data.basic) + Number(data.hra) + Number(data.conv) + Number(data.spAllow));
    data.grossSalary = amt.toFixed(2);

    var pfAmt = (Number(data.basic) * 12 / 100);
    data.pf = Math.round(pfAmt).toFixed(2);

    esicAmt = (Number(amt) * 1.75 / 100);
    data.esicAmt = Math.round(esicAmt).toFixed(2);
    if (Number(data.basic) < 6000) {
      pTamt = 0;
      data.profTax = Math.round(pTamt).toFixed(2);
    }
    if (Number(data.basic) >= 6000 && Number(data.basic) <= 8999) {
      pTamt = 80;
      data.profTax = Math.round(pTamt).toFixed(2);
    }
    if (Number(data.basic) >= 9000 && Number(data.basic) <= 11999) {
      pTamt = 150;
      data.profTax = Math.round(pTamt).toFixed(2);
    }
    if (Number(data.basic) >= 12000) {
      pTamt = 200;
      data.profTax = Math.round(pTamt).toFixed(2);
    }
    this.setState({
      employeeObject: data
    })
    // }
  }

  resetDetailsFields = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let employee = this.state.employeeObject;
    //employeeObject: {
    employee.idEmployee = 0;
    employee.updateStatus = 0;
    employee.idCompany = 0;
    employee.empCode = '';
    employee.empGrpId = 0;
    employee.empGrpName = '';
    employee.selectedEmpGrp = {};
    employee.empName = '';
    employee.designationId = 0;
    employee.designationName = '';
    employee.selectedDesignation = {};
    employee.departmentId = 0;
    employee.departmentName = '';
    employee.selectedDepartment = {};
    employee.address = '';
    employee.contactNo = '';
    employee.email = '';
    employee.joiningDate = '';
    employee.accNo = '';
    employee.pfNo = '';
    employee.esicNo = '';
    employee.basic = 0;
    employee.hra = 0;
    employee.conv = 0;
    employee.spAllow = 0;
    employee.grossSalary = '';
    employee.pf = '';
    employee.profTax = '';
    employee.esicAmt = '';
    employee.tdsGrpId = 0;
    employee.tdsGrpName = "";
    employee.selectedTDSGroups = {};
    employee.tds = '';
    employee.bloodgrpId = 0;
    employee.bloodgrpName = "";
    employee.selectedBloodGroups = {};
    employee.birthDate = '';
    employee.opDate = '';
    employee.opBalanceTypeId = 1;
    employee.opBalanceTypeName = 'CREDIT';
    employee.selectedOpBalanceType = {};
    employee.opBalance = '';
    employee.expClosing = "";
    employee.expOPTypeId = "";
    employee.expOPTypeName = "";
    employee.selectedExpOPType = {};
    employee.accSubHeadId = 0;
    employee.accSubHeadName = '';
    employee.selectedGeneralProducts = {};
    employee.remarks = '';
    employee.isLeave = false;
    employee.leaveDate = '';
    employee.e_Date = "";
    this.setState({ employeeObject: employee, validState: validState }, () => {
      this.getAllDropdownForEmployeeMaster();
    });
    //};
  }

  componentDidMount = () => {
    let params = new URLSearchParams(window.location.search);
    let id = params.get("id");
    if (id) {
      let urlId = decryptAES(id);
      if (urlId != null) {
        this.setState({ urlId: urlId });
      }
    }

    let prop = getAuthProps()
    //debugger
    if (prop.idCompany && prop.idCompany > 0) {
      this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
        this.procSelectAllRecordsSP();
        //this.getAllDropdownForEmployeeMaster();
      });
    } else {
      // window.location.href = "/Login";
    } setTimeout(() => {
      //this.removeDefaultBorders();
    }, 100);
  }
  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
  };

  procSelectAllRecordsSP = () => {
    let request = {
      formname: "Employee Master",
      idCompany: this.state.idCompany,
      allowToRateVisible: 1,
      idUser: 0,
      //idFinancialYear : null,
      //idPlant : 0,
    };
    this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
      if (response.statusCode == 200 && response.responseItem !== null) {
        let permissions = response.responseItem.responseContent[0][0];
        if (permissions.view) {
          let data = response.responseItem.responseContent[1];
          if (data.length > 0) {
            const dynamicColDefs = Object.keys(data[0]).map((key) => ({
              field: key.includes(".") ? key.replace(/\./g, "_") : key,
              headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
              minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
              flex: 1,
              filter: true,
              floatingFilter: true,
              hide: ["idEmployee", "sR.No"].includes(key) ? true : false,
              width: this.getPinnedWidth(key),
              // valueGetter: (params) => params.data[key],
              // valueFormatter: key.includes("date") || key.includes("invoiceDate")
              //   ? (params) => {
              //     if (!params.value) return "";
              //     return moment(params.value).format("DD-MM-YYYY");
              //   }
              //   : undefined,
              //pinned: ["idEmployee", "sR.No", "employeeName"].includes(key) ? "left" : null,
            }));
            //const priorityColumn = "bankName"; // Replace with the actual column name
            //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
            //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
            //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

            // const updatedColDefs = [
            //   ...pinnedColumns,
            //   ...(priorityColDef ? [priorityColDef] : []),
            //   ...otherColumns,
            // ];
            var colName = dynamicColDefs[0].field;
            let id = data ? data[0][colName] : 0;
            this.setState({
              rowData: data,
              colDefs: dynamicColDefs, //updatedColDefs,
              caption: "Employee Master",
              colName: colName
            }, () => {
              //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
              this.getAllDropdownForEmployeeMaster();
              this.setPermissions(permissions);

              if (this.state.urlId) {
                this.openPopUpFromURLId(this.state.urlId);
              }
            });
          } else {
            this.setPermissions(permissions);
            if (this.gridApi) {
              //this.gridApi.hideOverlay();
              //this.gridApi.showNoRowsOverlay();
              this.getAllDropdownForEmployeeMaster();
            }
          }
        } else {
          window.location.href = "/authentication/UnAuthorized";
        }
      }
    });
  }

  setPermissions = (permissions) => {
    let data = this.state.permissions;
    data.isAddEdit = permissions.addEdit;
    data.isDelete = permissions.delete;
    data.isView = permissions.view;
    this.setState({ permissions: data });
  }

  getColumnWidth = (key) => {
    const colwidth = {
      "employeeGroup": window.innerWidth * 0.1,
      "empCode": window.innerWidth * 0.05,
      "designation": window.innerWidth * 0.11,
      "department": window.innerWidth * 0.13,
      "employeeName": window.innerWidth * 0.2,
      "emp_Address": window.innerWidth * 0.08,
      "emp_ContactNo": window.innerWidth * 0.09,
      "status": window.innerWidth * 0.1,
    }
    return colwidth[key]
  }
  getPinnedWidth = (key) => {
    // const pinnedCol = {
    //     "idCashWithdraw": window.innerWidth * 0.06,
    //     "sR.No": window.innerWidth * 0.04,
    //     "employeeName": window.innerWidth * 0.18,
    // }
    // return pinnedCol[key]
  }

  getAllDropdownForEmployeeMaster = () => {
    this.masterEntryServices.getAllDropdownForEmployeeMaster(this.state.idCompany).then((response) => {
      //debugger
      if (response.statusCode == 200 && response.responseItem !== null) {
        let allData = response.responseItem.responseContent;
        let data = this.state.employeeObject;

        let designations = allData.filter(item => item.source === 'Master_Designation');
        data.designations = designations.map((p) => ({ value: p.id, label: p.name }));

        let departments = allData.filter(item => item.source === 'Master_Department');
        data.departments = departments.map((p) => ({ value: p.id, label: p.name }));

        let employeeGroups = allData.filter(item => item.source === 'Master_EmployeeGroup');
        data.employeeGroups = employeeGroups.map((p) => ({ value: p.id, label: p.name }));

        let generalProducts = allData.filter(item => item.source === 'Master_GeneralProduct');
        data.generalProducts = generalProducts.map((p) => ({ value: p.id, label: p.name }));

        let tdsGroups = allData.filter(item => item.source === 'Master_TDSGroup');
        data.tdsGroups = tdsGroups.map((p) => ({ value: p.id, label: p.name }));

        let employeeCount = allData.filter(item => item.source === 'EmployeeCount');
        data.empCode = employeeCount?.[0].id > 0 ? (employeeCount?.[0].id + 1) : (0 + 1);

        this.setState({
          employeeObject: data
        });
      } else {
        //this.usp_Master_EmployeeSelect()
      }
    });
  }

  submit = () => {
    const isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      let details = this.state.employeeObject;
      let requestData = {
        idEmployee: details.idEmployee,
        updateStatus: details.updateStatus,
        idCompany: this.state.idCompany,
        idDesignation: details.designationId,
        idDepartment: details.departmentId,
        employeeCode: details.empCode,
        employeeName: details.empName,
        emp_Address: details.address,
        emp_ContactNo: details.contactNo,
        dob: (details.birthDate && details.birthDate !== 'Invalid date') ? details.birthDate : null,
        joiningDate: (details.joiningDate && details.joiningDate !== 'Invalid date') ? details.joiningDate : null,
        bloodGroup: details.bloodgrpName,
        emailID: details.email,
        remarks: details.remarks,
        isLeave: details.isLeave,
        leaveDate: (details.leaveDate && details.leaveDate !== 'Invalid date') ? details.leaveDate : null,
        createLogin: false,
        username: "",
        password: "",
        allowLogin: false,
        e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
        isDeleted: false,
        deletedDate: null,
        pfNo: details.pfNo,
        esicNo: details.esicNo,
        salary: details.basic,
        hra: details.hra,
        conv: details.conv,
        specialAllowance: details.spAllow,
        grossSalary: details.grossSalary,
        pfAmt: details.pf,
        ptAmt: details.profTax,
        esic: details.esicAmt,
        idTDSGroup: details.tdsGrpId,
        tds: details.tds,
        opBalanceType: details.opBalanceTypeName,
        openingBalance: details.opBalance,
        //expenseOpBalanceType: details.expOPTypeName,
        //expenseClosing: details.expClosing,
        idEmployeeGroup: details.empGrpId,
        idGeneralProduct: details.accSubHeadId,
        opBalDate: (details.opDate && details.opDate !== 'Invalid date') ? details.opDate : null,
      };
      this.masterEntryServices.submitEmployeeMaster(requestData)
        .then((response) => {
          if (response.statusCode == 200 && response.responseItem !== null) {
            let dynamicData = response.responseItem.responseContent;
            if (dynamicData !== null) {
              if (this.state.employeeObject.updateStatus === 1) {
                this.SwalServices.Success("Updated successfully.");
              } else {
                this.SwalServices.Success("Saved successfully.");
              }
              if (this.state.urlId) {
                this.setState({ route: '/ledger-report' });
              } else {
                this.resetDetailsFields();
                // Call resetFields here after submission
                this.setState(
                  { isModalOpen: false },
                  () => {
                    this.procSelectAllRecordsSP(); // Fetch latest records
                  }
                );
              }
            } else {
              this.procSelectAllRecordsSP();
            }
          } else {
            this.setState(
              { isModalOpen: false },
              () => {
                this.SwalServices.Error(response.message);
                this.procSelectAllRecordsSP(); // Fetch latest records
              }
            );
          }
        });
    }
  };

  openPopUpFromURLId = (id) => {
    let details = this.state.employeeObject;
    details.idEmployee = id;
    this.setState({ employeeObject: details }, () => {
      this.getEmployeeMasterDetails(this.state.employeeObject.idEmployee);
    });
  };

  getEmployeeMasterDetails = (id) => {
    this.masterEntryServices.getEmployeeMasterDetails(id).then((response) => {
      //debugger
      if (response.statusCode == 200 && response.responseItem !== null) {
        let employee = this.state.employeeObject;
        let responseData = response.responseItem.responseContent[0];
        employee.idEmployee = responseData.idEmployee;
        employee.updateStatus = 1;
        employee.idCompany = responseData.idCompany;
        employee.empCode = responseData.employeeCode;
        employee.empGrpId = responseData.idEmployeeGroup;
        employee.empGrpName = responseData.idEmployeeGroup > 0 ? employee.employeeGroups?.find(item => item.value === responseData.idEmployeeGroup)?.label : "";
        employee.selectedEmpGrp = responseData.idEmployeeGroup > 0 ? employee.employeeGroups?.find(item => item.value === responseData.idEmployeeGroup) : {};
        employee.empName = responseData.employeeName;
        employee.designationId = responseData.idDesignation;
        employee.designationName = responseData.idDesignation > 0 ? employee.designations?.find(item => item.value === responseData.idDesignation)?.label : "";
        employee.selectedDesignation = responseData.idDesignation > 0 ? employee.designations?.find(item => item.value === responseData.idDesignation) : {};
        employee.departmentId = responseData.idDepartment;
        employee.departmentName = responseData.idDepartment > 0 ? employee.departments?.find(item => item.value === responseData.idDepartment)?.label : "";
        employee.selectedDepartment = responseData.idDepartment > 0 ? employee.departments?.find(item => item.value === responseData.idDepartment) : {};
        employee.address = responseData.emp_Address;
        employee.contactNo = responseData.emp_ContactNo;
        employee.email = responseData.emailID;
        employee.joiningDate = moment(responseData.joiningDate).format('YYYY-MM-DD');
        employee.accNo = responseData.accountNo;
        employee.pfNo = responseData.pfNo;
        employee.esicNo = responseData.esicNo;
        employee.basic = responseData.salary;
        employee.hra = responseData.hra;
        employee.conv = responseData.conv;
        employee.spAllow = responseData.specialAllowance;
        employee.grossSalary = responseData.grossSalary;
        employee.pf = responseData.pfAmt;
        employee.profTax = responseData.ptAmt;
        employee.esicAmt = responseData.esic;
        employee.tdsGrpId = responseData.idtdsGroup;
        employee.tdsGrpName = responseData.idtdsGroup > 0 ? employee.tdsGroups?.find(item => item.value === responseData.idtdsGroup)?.label : "";
        employee.selectedTDSGroups = responseData.idtdsGroup > 0 ? employee.tdsGroups?.find(item => item.value === responseData.idtdsGroup) : {};
        employee.tds = responseData.tds;
        employee.bloodgrpName = responseData.bloodGroup;
        employee.bloodgrpId = responseData.bloodGroup ? employee.bloodGroups?.find(item => item.label === responseData.bloodGroup)?.value : "";
        employee.selectedBloodGroups = responseData.bloodGroup ? employee.bloodGroups?.find(item => item.label === responseData.bloodGroup) : {};
        employee.birthDate = moment(responseData.dob).format('YYYY-MM-DD');
        employee.opDate = moment(responseData.opBalDate).format('YYYY-MM-DD');
        employee.opBalanceTypeName = responseData.opBalanceType;
        employee.opBalanceTypeId = responseData.opBalanceType ? employee.types?.find(item => item.label === responseData.opBalanceType)?.value : "";
        employee.selectedOpBalanceType = responseData.opBalanceType ? employee.types?.find(item => item.label === responseData.opBalanceType) : {};
        employee.opBalance = responseData.openingBalance;
        //employee.expClosing = responseData.expenseClosing;
        //employee.expOPTypeId = responseData.expenseOpBalanceType;
        //employee.expOPTypeName = "";
        //employee.selectedExpOPType = {};
        employee.accSubHeadId = responseData.idGeneralProduct;
        employee.accSubHeadName = responseData.idGeneralProduct > 0 ? employee.generalProducts?.find(item => item.value === responseData.idGeneralProduct)?.label : "";
        employee.selectedGeneralProducts = responseData.idGeneralProduct > 0 ? employee.generalProducts?.find(item => item.value === responseData.idGeneralProduct) : {};
        employee.remarks = responseData.remarks;
        employee.isLeave = responseData.isLeave;
        employee.leaveDate = moment(responseData.leaveDate).format('YYYY-MM-DD');;
        employee.e_Date = responseData.e_Date;
        this.setState({
          employeeObject: employee,
          isModalOpen: true
        });
      } else {
        //this.usp_Master_EmployeeSelect()
      }
    });
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className='employee-master'>
        <div className='data-display'>
          <div className='data-display-inner relative'>
            <ButtonGrp buttons={['add', 'print', 'delete']}
              onClickHandlers={{
                add: () => this.openPopUpForAddingItem(),
                // update: () => this.openPopUpForUpdateItem(),
                print: this.handlePrint,
                delete: this.handleDelete,
              }}
            />
            <EmployeeMasterPopup
              isModalOpen={this.state.isModalOpen}
              setOpenModel={this.setOpenModel.bind(this)}
              employeeObject={this.state.employeeObject}
              handleChange={this.handleChange.bind(this)}
              close={this.closePopup.bind(this)}
              submit={this.submit.bind(this)}
              validState={this.state.validState}
            />
            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                <div className="table-inner">
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Employee master</h1>
                </div>
                <AgGridReact
                  rowData={this.state.rowData}
                  rowHeight={this.state.rowHeight}
                  columnDefs={this.state.colDefs}
                  pagination={true}
                  paginationPageSize={this.state.paginationPageSize}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  onGridReady={this.onGridReady}
                  overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                  overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
